import {DEBUG_FLAG} from './debug'

export const API_BASE_URL = DEBUG_FLAG() ? 'http://127.0.0.1:20110/api/' : 'https://web.ectool.de/api/';
// export const API_BASE_URL = 'http://localhost:5000/api/';
// export const API_BASE_URL = 'https://web.ectool.de/api/';
// export const API_BASE_URL = 'https://web.ectool.de:21116/api/';
